import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import routes from "../../../../../routes";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schemaGenerator from "../../../../schemas/schemaGeneratorLabReportUpload";
import { Button, notification, PageHeader, Spin } from "antd";
import LabReportUploadForm from "../../../../forms/LabReportUploadForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sliceKey, reducer, actions } from "./slice";
import { labReportUploadSaga } from "./sagas";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import * as selectors from "./selectors";
import { actions as orderListingActions } from "../OrderListing/slice";

/* const keyParameters = [
  {
    name: "Microbial Fungus",
    minOperationalValue: 10,
    maxOperationalValue: 20,
  },
  {
    name: "Aflatoxin B1",
    minOperationalValue: 1,
    maxOperationalValue: 2,
  },
  {
    name: "Lead",
    minOperationalValue: 50,
    maxOperationalValue: 60,
  },
]; */

function toCamelCase(str) {
  // Split the string by spaces, hyphens, or underscores
  const words = str.split(/[\s-_]+/);

  // Transform the first word to lowercase
  let camelCaseStr = words[0].toLowerCase();

  // Capitalize the first letter of each subsequent word and concatenate them
  for (let i = 1; i < words.length; i++) {
    camelCaseStr += words[i][0].toUpperCase() + words[i].slice(1).toLowerCase();
  }

  return camelCaseStr;
}

const defaultObjectForReactHookForm = (keyParameters) => {
  let requiredObj = {};
  if (keyParameters.length) {
    keyParameters.forEach((key) => {
      let camelCaseString = toCamelCase(key.parameter);
      requiredObj[`${camelCaseString}`] = "";
    });
    return requiredObj;
  }
};

function dataToGenerateForm(keyParameters) {
  let requiredArray = [];
  for (let i = 0; i < keyParameters.length; i += 2) {
    let arrayOfParameters = [];
    arrayOfParameters.push(keyParameters[i]);
    if (i + 1 < keyParameters.length)
      arrayOfParameters.push(keyParameters[i + 1]);
    requiredArray.push(arrayOfParameters);
  }
  return requiredArray;
}

const ReportUpload = () => {
  const { orderId } = useParams();
  const id = orderId;

  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: labReportUploadSaga });

  const dispatch = useDispatch();
  const history = useHistory();
  //history.push(routes.labs.dashboard);

  useEffect(() => {
    dispatch(actions.fetchOrderDetails(id));
  }, [dispatch, id]);

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  const [loaderWhileSaving, setLoaderWhileSaving] = useState(false);
  const orderDetails = useSelector(selectors.selectOrderDetails) || null;

  useEffect(() => {
    if (orderDetails && orderDetails.labResponseId) {
      history.push(routes.labs.dashboard);
      notification.error({
        message: `Response has already been provided for ${orderDetails.orderId}`,
      });
    }
  }, [dispatch, orderDetails, history]);

  let keyParameters = orderDetails
    ? orderDetails.packages[0].package.keyParameters
    : [];

  let schema = null;
  let dataForForm = [];
  if (keyParameters.length) {
    //console.log(defaultObjectForReactHookForm(keyParameters));
    keyParameters = keyParameters.map((obj) => {
      return {
        ...obj,
        key: toCamelCase(obj.parameter),
      };
    });
    //console.log(keyParameters);
    schema = schemaGenerator(orderDetails.sampleVariant);
    //console.log(schema);
    dataForForm = dataToGenerateForm(keyParameters);
    //console.log("dataForForm", dataForForm);
  }
  //console.log(orderDetails);
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      labReport: "",
      labReportMetadata: "",
      overallSafetyCompliant: "",
      overallQualityCompliant: "",
      overallLabellingCompliant:
        orderDetails?.sampleVariant === "Loose" ? "NA" : "",
      overallSampleClassification: "",
      ...defaultObjectForReactHookForm(keyParameters),
    },
    resolver: yupResolver(schema),
  });

  let disableFields = {
    overallLabellingCompliant:
      orderDetails?.sampleVariant === "Loose" ? true : false,
  };
  const onSubmit = (data) => {
    console.log("Save Lab Details");
    console.log(data);

    let keyParametersValues = [];
    Object.keys(data).forEach((key) => {
      if (key !== "labReport" && key !== "labReportMetadata") {
        let requiredParameter = keyParameters.filter((keyParameter) => {
          if (keyParameter.key === key) return keyParameter;
        });

        if (requiredParameter.length) {
          let requiredObj = {
            parameter: requiredParameter[0].parameter,
            parameterValue: data[`${key}`],
          };
          keyParametersValues.push(requiredObj);
        }
      }
    });

    let payload = {
      labReport: data.labReport,
      labReportMetadata: data.labReportMetadata,
      orderId: orderDetails.orderId,
      overallSafetyCompliant: data.overallSafetyCompliant,
      overallQualityCompliant: data.overallQualityCompliant,
      overallLabellingCompliant: data.overallLabellingCompliant,
      overallSampleClassification: data.overallSampleClassification,
      id,
      keyParametersValues,
      onSuccess: () => {
        notification.success({
          message: "Report Uploaded Successfully!!!",
        });
        dispatch(orderListingActions.setActiveNavOption("REPORT UPLOADED"));

        history.push(routes.labs.dashboard);
      },
      onFailure: () => {
        notification.error({
          message: "Error Saving Response!",
          description: error,
        });
        setLoaderWhileSaving(false);
      },
    };
    console.log(payload);
    setLoaderWhileSaving(true);
    dispatch(actions.uploadReport(payload));
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title="Lab Results Form"
        subTitle={
          orderDetails
            ? `${orderDetails.orderId},  ${orderDetails.sampleVariant} Variant`
            : ""
        }
        extra={[
          <Button key="1" onClick={() => history.goBack()}>
            Back
          </Button>,
          <Button
            disabled={loading || loaderWhileSaving ? true : false}
            loading={loading || loaderWhileSaving ? true : false}
            key="2"
            type="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh) - 50px",
          padding: "24px",
          backgroundColor: "#ffffff",
          marginTop: "20px",
        }}
      >
        {loading || loaderWhileSaving ? (
          <Spin
            size="large"
            style={{
              height: "calc(70vh)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        ) : (
          <LabReportUploadForm
            keyParameters={dataForForm}
            control={control}
            setValue={setValue}
            watch={watch}
            errors={errors}
            options={{ disableFields }}
          />
        )}
      </div>
    </>
  );
};

export default ReportUpload;
